exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block[data-v-2d4d4e17]{margin:50px auto;text-align:center}\n", ""]);

// exports
